const StoreSearchConfig = {
  'store.search.back': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '返回',
    c: {
      type: 'constant',
      value: 'prev',
    },
  },
  'store.search.search': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '搜索',
    c: {
      type: 'constant',
      value: 'search',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },
  'store.search.empty': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '清空历史记录',
    c: {
      type: 'constant',
      value: 'empty',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },
  'store.search.history': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '历史搜索词',
    c: {
      type: 'constant',
      value: 'history',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },

  // 搜索商品列表
  'store.wrapper_store.prev': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '返回',
    c: {
      type: 'constant',
      value: 'prev',
    },
  },
  'store.wrapper_store.delete': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '删除',
    c: {
      type: 'constant',
      value: 'delete',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },
  'store.wrapper_store.sort': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '排序',
    c: {
      type: 'constant',
      value: 'sort',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },
  'store.wrapper_store.search': {
    operation: ['TOUCH'],
    title: '搜索',
    c: {
      type: 'constant',
      value: 'search',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },
  'store.wrapper_store.list': {
    operation: ['VISIBLE'],
    title: '店内商品搜索',
    getParse: {
      type: 'variable',
      func: function (item = {}) {
        const params = new URLSearchParams(item?.item?.traceData);
        const data = {
          isViewable: item?.isViewable,
          key: item?.key,
          b: 'wrapper_store',
          c: 'product',
          d: item?.index + 1,
          iid: params.toString() ?? '',
          scmv2: item?.item?.traceData?.scm ?? '',
        };
        return data;
      },
    },
  },
  'store.wrapper_store.list.click': {
    operation: ['TOUCH'],
    title: '商品点击',
    c: {
      type: 'constant',
      value: 'product',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const params = new URLSearchParams(traceData);
        return params && params.toString();
      },
    },
  },
};

export default StoreSearchConfig;
